/**
 * @generated SignedSource<<f749623cfd7c92fbc9cae7e3dc027621>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessKnownRolesData$data = {
  readonly knownGroups: ReadonlyArray<{
    readonly implies: ReadonlyArray<string>;
    readonly label: { default: string } & Record<string, string | undefined>;
    readonly large: boolean;
    readonly role: string;
    readonly sortKey: string | null | undefined;
  }>;
  readonly " $fragmentType": "AccessKnownRolesData";
};
export type AccessKnownRolesData$key = {
  readonly " $data"?: AccessKnownRolesData$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessKnownRolesData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccessKnownRolesData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "KnownGroup",
      "kind": "LinkedField",
      "name": "knownGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "large",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "703f46c4077b0e2e919f5cac19f07e8c";

export default node;
